import {
  Box,
  Card,
  CardContent,
  Chip,
  IconButton,
  InputAdornment,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";

import SearchIcon from "@mui/icons-material/Search";
import DeleteIcon from "@mui/icons-material/Delete";
import { useState } from "react";
import { useSelector } from "react-redux";
import { license_types_suffix } from "../../../data/dbpr";
import axios from "axios";

const QuickActionValidateLicense = ({
  foundContractor,
  setFoundContractor,
}) => {
  const currentSession = useSelector((state) => state.sessions.currentSession);

  const [licenseNumber, setLicenseNumber] = useState("");
  const [lookupLicenseLoading, setLookupLicenseLoading] = useState(false);
  const [invalidLicenseText, setInvalidLicenseText] = useState("");

  const validateLicenseNumberPrefix = (licenseNumber) => {
    // Extract the prefix part from the license number
    const prefix = licenseNumber.match(/^[A-Za-z]+/);

    if (prefix) {
      const prefixStr = prefix[0];
      // Check if the extracted prefix exists in the license_types_suffix
      for (let key in license_types_suffix) {
        if (license_types_suffix[key].includes(prefixStr)) {
          return true;
        }
      }
    }
    return false;
  };

  const handleLookupLicense = async () => {
    try {
      setLookupLicenseLoading(true);

      if (licenseNumber === "") {
        setInvalidLicenseText("License Number Is Required");
        return;
      }

      if (!validateLicenseNumberPrefix(licenseNumber)) {
        setInvalidLicenseText("License Number Is Invalid");
        return;
      }

      const resp = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/nocApi/data/validate-license`,
        {
          license_number: licenseNumber,
          currentSession: currentSession,
          quickLookup: true,
        },
        { withCredentials: true }
      );

      if (resp?.data?.success) {
        setFoundContractor(resp?.data?.data);
      } else {
        setInvalidLicenseText(resp?.data?.message);
      }
    } catch (error) {
      setInvalidLicenseText(error?.response?.data?.message);
    } finally {
      setLookupLicenseLoading(false);
      setTimeout(() => {
        setInvalidLicenseText("");
      }, 5000);
    }
  };

  const handleLicenseChange = async (event) => {
    const { value } = event.target;

    setLicenseNumber(value.toUpperCase());
  };

  return (
    <Card
      sx={{
        boxShadow: "2px 6px 12px rgba(0, 0, 0, 0.5) !important",
      }}
    >
      <CardContent
        sx={{
          pt: 0,
          minHeight: "15rem",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <Box>
          <Typography
            variant="h6"
            textAlign="center"
            gutterBottom
            mb={2}
            mt={2}
          >
            Lookup Contractor
          </Typography>
          <TextField
            fullWidth
            disabled={lookupLicenseLoading || foundContractor}
            name="licenseNumber"
            label="License Number"
            value={licenseNumber}
            onChange={handleLicenseChange}
            slotProps={{
              input: {
                endAdornment: (
                  <InputAdornment position="end">
                    {foundContractor && foundContractor?.status && (
                      <Chip
                        label={foundContractor.status}
                        color={
                          ["Suspended", "Inactive"].includes(
                            foundContractor.status
                          )
                            ? "error"
                            : "success"
                        }
                        size="small"
                        sx={{ fontWeight: "bold" }}
                      />
                    )}
                  </InputAdornment>
                ),
              },
            }}
          />
        </Box>

        <Box sx={{ minHeight: "2rem" }}>
          <Typography color="error" variant="body2" textAlign="center">
            {invalidLicenseText}
          </Typography>
        </Box>
        <Box textAlign="center" gap={1} sx={{ display: "flex" }}>
          <LoadingButton
            disabled={Boolean(foundContractor)}
            loading={lookupLicenseLoading}
            fullWidth
            variant="contained"
            color="warning"
            onClick={handleLookupLicense}
            endIcon={<SearchIcon />}
          >
            Lookup
          </LoadingButton>
          <Tooltip title="Clear License Number">
            <span>
              <IconButton
                onClick={() => {
                  setLicenseNumber("");
                  setFoundContractor(null);
                }}
                disabled={licenseNumber === "" || lookupLicenseLoading}
                sx={{
                  color: "error.main",
                  "&:hover": {
                    backgroundColor: "rgba(255, 0, 0, 0.1)",
                  },
                }}
              >
                <DeleteIcon />
              </IconButton>
            </span>
          </Tooltip>
        </Box>
      </CardContent>
    </Card>
  );
};

export default QuickActionValidateLicense;
